<template>
  <div class="ev-map-road">
    <!-- START Search Text Box -->
    <div class="row search-station-text-box">
      <div class="col-md-6 ct-mb-padding-bottom-75">
        <b-form-input type="text" placeholder="출발지를 입력하세요." v-model="searchRoadOptions.startPoint.keyword"
                      @keypress.enter="searchPlace('start')" />
      </div>
      <div class="col-md-6">
        <b-form-input type="text" placeholder="도착지를 입력하세요." v-model="searchRoadOptions.endPoint.keyword"
                      @keypress.enter="searchPlace('end')" />
      </div>
    </div>
    <!-- END Search Text Box -->

    <!-- START Search Conditions -->
    <b-collapse id="detailSearchRoadCollapse" v-model="detailSearchRoadCheck">
<!--      <div class="row mt-2">-->
<!--        <h6><i class="mdi mdi-database-search icon-padding-right" />상세 검색</h6>-->
<!--      </div>-->
      <div class="row">
        <div class="col-md-6 mb-2">
          <multiselect v-model="searchRoadOptions.agency" :options="agencyOptions"
                       label="text" placeholder="" select-label=""
                       :allow-empty="false" deselect-label="">
            <span slot="noResult">No Result</span>
          </multiselect>
        </div>
        <div class="col-md-6 mb-2">
          <multiselect v-model="searchRoadOptions.kind" :options="kindOptions"
                       label="text" placeholder="" select-label=""
                       :allow-empty="false" deselect-label="">
            <span slot="noResult">No Result</span>
          </multiselect>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 mb-2" v-for="item in chargerTypeOptions">
          <b-button variant="tansparent" class="w-100 btn-rounded" size="sm"
                    :class="isChargerTypeSelected(`${item.value}`) ? 'charger-type-select' : 'charger-type-unselect'"
                    @click="chargerTypeToggle(`${item.value}`)">
            <span class="font-size-12">{{ item.label }}</span>
          </b-button>
        </div>
      </div>
    </b-collapse>
    <!-- END Search Conditions -->

    <!-- START Search Road Button Area -->
    <div class="row mt-2">
      <div class="col-6">
        <div class="form-check form-switch mt-1">
          <input type="checkbox" class="form-check-input" id="roadFlexSwitchCheckDefault"
                 v-model="detailSearchRoadCheck"
                 :aria-expanded="detailSearchRoadCheck ? 'true' : 'false'"
                 aria-controls="detailSearchRoadCollapse" />
          <label class="form-check-label" for="roadFlexSwitchCheckDefault">상세 검색</label>
        </div>
      </div>
      <search-buttons layout-class="col-6" btn-size="sm" :reset-fn="resetRoad" :search-fn="searchRoad" />
    </div>
    <!-- END Search Road Button Area -->

    <!-- START Road Result List -->
    <div class="search-road-result">
      <!-- START Search Place List -->
      <div v-if="kakaoPlaceResult.list.length > 0">
        <hr/>
        <div class="mb-2">
          <span class="search-word ct-padding-left-50 badge rounded-pill badge-soft-main-green">{{ searchRoadType === 'start' ? '출발지' : '도착지' }}</span>
          <span class="search-word ct-padding-left-50">{{ searchRoadKeyword }}</span>
          <span class="ct-padding-left-50">검색 결과</span>
        </div>
        <hr/>
        <div id="search-road-result-accordion" class="search-road-result-accordion" :style="getAccordionStyle('kakao')">
          <div class="ct-accordion" v-for="(item, i) in kakaoPlaceResult.list" :key="item.id" @click="showOnMap('road', searchRoadType, item, i)">
            <div class="ct-accordion-header">
              <div class="ct-accordion-title">
                <i class="bx bxs-map ct-padding-right-25" />
                <span>{{ item.place_name }}</span>
              </div>
              <div class="ct-accordion-content mt-1">
                <span :title="`${item.address_name}`">- {{ $_utils.textLengthOverCut(item.address_name, 40, '') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3" style="text-align: right">
          <b-pagination class="pagination-no-border" align="center" size="sm" v-model="kakaoPlaceResult.page.current"
                        first-number last-number prev-text="<" next-text=">"
                        :total-rows="kakaoPlaceResult.page.totalCount" :per-page="kakaoPlaceResult.page.perPage" @change="onPageChange" />
        </div>
      </div>
      <!-- END Search Place List -->

      <!-- START Road Result -->
      <div v-else-if="kakaoPlaceResult.list.length < 1 && !$_utils.isEmpty(aroundStations)">
        <hr/>
        <div class="ct-padding-left-50">
          <b-form-group class="ct-mb-margin-bottom-100" label-class="form-check-label"
                        label="경로 탐색 옵션" label-for="searchEvseType"
                        label-cols="3" content-cols="9">
            <div id="searchEvseType" class="col-form-label">
              <div class="form-check form-check-inline" v-for="(item, i) in priorityTypeOptions">
                <input class="form-check-input" type="radio" :id="`stationRadio${i}`"
                       :value="`${item.value}`" v-model="priority"
                       @change="searchPriority()" />
                <label class="form-check-label" :for="`stationRadio${i}`">{{ item.name }}</label>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="driving-route-info">
          <div class="mb-2">
            <i class="bx bx bxs-car icon-padding-right" />
            <span class="search-word ct-padding-right-25">{{ searchRoadOptions.startPoint.keyword }}</span>
            <span>에서</span>
            <br/>
            <span class="search-word ct-padding-left-100 ct-padding-right-25">{{ searchRoadOptions.endPoint.keyword }}</span>
            <span>까지</span>
          </div>
          <div>
            <i class="bx bxs-flag-alt" />
            <span> 거리: </span><span class="search-word">{{ ((roadPathResult.distance)/1000).toFixed(2) }} km</span>
            <br/>
            <i class="bx bxs-timer" />
            <span> 시간: </span><span class="search-word">{{ secToTime(roadPathResult.duration) }}</span>
          </div>
        </div>
        <hr/>
        <div class="font-size-13 text-bold my-2">
          • 충전소 목록 ({{aroundStations.length}} 개)
        </div>

        <!-- START Station Result List -->
        <ev-map-station-list sidebar-mode="road"
                             collapse-id="collapse-road-result"
                             :detail-option-check="detailSearchRoadCheck"
                             :station-result-list="aroundStations"
                             @showOnMap="showOnMap" />
        <!-- End Station Result List -->

        <div class="mt-3" style="text-align: right">
          <b-pagination class="pagination-no-border" align="center" size="sm" v-model="aroundStationPage.current"
                        first-number last-number prev-text="<" next-text=">"
                        :total-rows="aroundStationPage.totalCount" :per-page="aroundStationPage.perPage" @change="onPageChange" />
        </div>

      </div>
      <!-- END Road Result -->
    </div>
    <!-- END Road Result List -->
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SearchButtons from "@/views/components/searchButtons.vue";
import EvMapStationList from "@/views/pages/maps/evMapStationList.vue";

export default {
  components: { EvMapStationList, SearchButtons, Multiselect },
  props: {
    currentLocation: Object,
    searchKeyword: String,
    aroundStations: Array,
  },
  data() {
    return {
      detailSearchRoadCheck: false,
      agencyOptions: [],
      kindOptions: [],
      chargerTypeOptions: [
        { label: 'DC콤보', value: '04' },
        { label: '차데모', value: '01' },
        { label: 'AC3상', value: '07' },
        { label: '완속', value: '02' }
      ],
      searchRoadOptions: {
        startPoint: {
          keyword: this.currentLocation.tempGeo === false ? '현재 위치' : '아이온 커뮤니케이션즈',
          lat: this.currentLocation.lat,
          lng: this.currentLocation.lng,
        },
        endPoint: {
          keyword: null,
          lat: null,
          lng: null
        },
        agency: { value: 'all', text: '운영 기관 (전체)' },
        kind: { value: 'all', text: '시설 유형 (전체)' },
        chargerType: ['01', '02', '04', '07']
      },
      searchRoadType: null,   // 출발지 or 도착지 검색 종류
      searchRoadKeyword: null,
      kakaoPlaceResult: {
        page: {
          current: 1,   // Kakao
          totalCount: 0,   // Kakao
          perPage: 15   // Kakao
        },
        list: []
      },
      aroundStationPage: {
        current: 1,
        totalCount: this.currentLocation.length,
        perPage: 100
      },
      roadPathResult: null,
      priority: 'RECOMMEND',   // 경로 검색 방법 (추천)
      priorityTypeOptions: [
        { value: 'RECOMMEND', name: '추천 경로' },
        { value: 'TIME', name: '최단 시간' },
        { value: 'DISTANCE', name: '최단 경로' }
      ],
      activeAccordionId: null,
      chargerResult: null
    }
  },
  watch: {
    aroundStations: {
      handler(newVal, oldVal) {
        const vm = this;

        vm.activeAccordionId = null;
        if (newVal.length === 1) {
          this.$nextTick(() => {
            vm.autoOpenCollapse();
          });
          if (!this.$_utils.isEmpty(oldVal) && (newVal[0].statId === oldVal[0].statId)) {
            this.$root.$emit('bv::toggle::collapse', 'collapse-road-result-0');
          }
          // vm.scrollToTop('#search-station-result-accordion');
        }
      },
    }
  },
  created() {
    const vm = this;

    vm.getAgencyOptions();
    vm.getKindOptions();
  },
  methods: {
    getAgencyOptions() {
      const vm = this;

      vm.agencyOptions = [];
      vm.agencyOptions = Object.entries(this.$_app.code.busiId).map(([key, value]) => ({ value: key, text: value }));
      vm.agencyOptions.unshift({ value: 'all', text: '운영 기관 (전체)' });
    },
    getKindOptions() {
      const vm = this;

      vm.kindOptions = [];
      vm.kindOptions = Object.entries(this.$_app.code.parentPlaceType).map(([key, value]) => ({ value: key, text: value }));
      vm.kindOptions.unshift({ value: 'all', text: '시설 유형 (전체)' });
    },
    isChargerTypeSelected(val) {
      const vm = this;
      return vm.searchRoadOptions.chargerType.includes(val);
    },
    chargerTypeToggle(val) {
      const vm = this;
      const _index = vm.searchRoadOptions.chargerType.indexOf(val);

      if (_index > -1) {
        vm.searchRoadOptions.chargerType.splice(_index, 1);
      } else {
        vm.searchRoadOptions.chargerType.push(val);
      }
    },
    searchPlace(type, opt) {
      const vm = this;
      vm.searchRoadType = type;

      if (opt === 'fromHere') {
        vm.searchRoadOptions.startPoint.keyword = vm.currentLocation.tempGeo === false ? '현재 위치' : '아이온 커뮤니케이션즈';
        vm.searchRoadOptions.startPoint.lat = vm.currentLocation.lat;
        vm.searchRoadOptions.startPoint.lng = vm.currentLocation.lng;
        vm.searchRoadOptions.endPoint.keyword = vm.searchKeyword;
      }

      if (vm.searchRoadType === 'start' && this.$_utils.isEmpty(vm.searchRoadOptions.startPoint.keyword)) {
        this.$swal('출발지를 입력하세요.', '', 'warning');
      } else if (vm.searchRoadType === 'end' && this.$_utils.isEmpty(vm.searchRoadOptions.endPoint.keyword)) {
        this.$swal('도착지를 입력하세요.', '', 'warning');
      } else {
        vm.getRoadKakaoKeywordItems();
      }
    },
    getRoadKakaoKeywordItems() {
      const vm = this;
      vm.searchRoadKeyword = vm.searchRoadType === 'start' ? vm.searchRoadOptions.startPoint.keyword : vm.searchRoadOptions.endPoint.keyword;

      // 장소 검색 객체 생성
      const ps = new window.kakao.maps.services.Places();

      ps.keywordSearch(vm.searchRoadKeyword , (data, status, pagination) => {
        if (status === window.kakao.maps.services.Status.OK) {
          console.log('data', data)
          vm.kakaoPlaceResult.page = pagination;
          vm.kakaoPlaceResult.list = data;
        } else if (status === window.kakao.maps.services.Status.ZERO_RESULT) {
          this.$swal('카카오 검색 결과가 존재하지 않습니다.', '', 'warning');
          vm.kakaoPlaceResult.page = pagination;
        } else if (status === window.kakao.maps.services.Status.ERROR) {
          this.$swal('카카오 검색 결과 중 오류가 발생했습니다.', '', 'error');
        }
      });
    },
    getAccordionStyle(type) {
      let height;

      if (type === 'kakao') { // 카카오 목적지 검색
        if (this.$store.state.layout.browserMode === 'web') {
          height = { height: this.detailSearchRoadCheck ? 'calc(100vh - 470px)' : 'calc(100vh - 354px)' }
        } else {
          height = { height: this.detailSearchRoadCheck ? window.innerHeight-580 + 'px' : window.innerHeight-350 + 'px' }
        }
      // } else { // 길찾기 검색
      //   if (this.detailSearchRoadCheck) {
      //     height = { height: 'calc(100vh - 540px)' }
      //   } else {
      //     height = { height: 'calc(100vh - 420px)' }
      //   }
      }
      return height;
    },
    showOnMap(type, subType, item) {
      const vm = this;

      if (subType === 'start') {
        vm.searchRoadOptions.startPoint = {
          keyword: item.place_name,
          lat: item.y,
          lng: item.x
        };
      } else if (subType === 'end') {
        vm.searchRoadOptions.endPoint = {
          keyword: item.place_name,
          lat: item.y,
          lng: item.x
        };
      }

      this.$emit('showOnMap', type, subType, item);
    },
    resetRoad() {
      const vm = this;

      vm.searchRoadOptions = {
        startPoint: {
          keyword: null,
          lat: null,
          lng: null
        },
        endPoint: {
          keyword: null,
          lat: null,
          lng: null
        },
        agency: { value: 'all', text: '운영 기관 (전체)' },
        kind: { value: 'all', text: '시설 유형 (전체)' },
        chargerType: ['01', '02', '04', '07']
      };
      vm.priority = 'RECOMMEND';
      vm.kakaoPlaceResult.list = [];
      vm.aroundStations = [];
    },
    searchRoad() {
      const vm = this;

      if (this.$_utils.isEmpty(vm.searchRoadOptions.startPoint.keyword) || this.$_utils.isEmpty(vm.searchRoadOptions.startPoint.lat)) {
        this.$swal('출발지를 검색 후, 목록에서 선택해주세요.', '', 'warning');
      } else if (this.$_utils.isEmpty(vm.searchRoadOptions.endPoint.keyword) || this.$_utils.isEmpty(vm.searchRoadOptions.endPoint.lat)) {
        this.$swal('도착지를 검색 후, 목록에서 선택해주세요.', '', 'warning');
      } else {
        const _url = `https://apis-navi.kakaomobility.com/v1/directions?`
            + `origin=`+vm.searchRoadOptions.startPoint.lng+`,`+vm.searchRoadOptions.startPoint.lat+`,name=`+vm.searchRoadOptions.startPoint.keyword
            + `&destination=`+vm.searchRoadOptions.endPoint.lng+`,`+vm.searchRoadOptions.endPoint.lat+`,name=`+vm.searchRoadOptions.endPoint.keyword
            + `&priority=`+vm.priority;

        this.$axios.get(`${_url}`, {
          headers: {
            Authorization: `KakaoAK ${process.env.VUE_APP_KAKAOMAP_RESTKEY}`
          }
        }).then((res) => {
          if (res.data.routes[0].result_code !== 0) {
            this.$swal(res.data.routes[0].result_msg, '', 'error');
            return false;
          } else {
            console.log('map result', res.data.routes[0].sections[0].roads)
            vm.kakaoPlaceResult.list = [];
            vm.roadPathResult = res.data.routes[0].sections[0];
            //vm.roadPathResult = res.data.routes[0].sections[0].roads;

            this.$emit('drawRoad', vm.roadPathResult, vm.searchRoadOptions);
          }
        });
      }
    },
    onPageChange(val) {
      const vm = this;
      vm.kakaoPlaceResult.page.current = val;

      if (vm.kakaoPlaceResult.page.totalCount > 15) {
        this.kakaoPlaceResult.page.gotoPage(vm.kakaoPlaceResult.page.current);
      }
    },
    searchPriority() {
      const vm = this;
      vm.searchRoad();
    },
    secToTime(duration) {
      let seconds = Math.floor(duration % 60),
          minutes = Math.floor((duration / 60) % 60),
          hours = Math.floor((duration / (60 * 60)) % 24);

      hours = hours < 1 ? '' : hours + ' 시간 ';
      minutes = hours < 1 && minutes < 0 ? '' : minutes + ' 분 ';

      return hours + minutes + seconds + ' 초';
    }
  }
}
</script>